module.exports = __webpack_public_path__ + "img/sort-asc.4a5d3054.svg";